class CustomerIntegrationInputController {
  constructor() {
    this.name = 'customerIntegrationInput';
  }
}

export default CustomerIntegrationInputController;



// WEBPACK FOOTER //
// ./app/components/customerIntegrationInput/customerIntegrationInput.controller.js